module.exports = __webpack_public_path__ + "static/media/ZF.8315ba34.pdf";